'use strict';

var _classCallCheck = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _assertThisInitialized = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var Stringify = require('./stringify');

var internals = {};

module.exports = /*#__PURE__*/function (_Error) {
  _inherits(_class, _Error);

  var _super = _createSuper(_class);

  function _class(args) {
    var _this;

    _classCallCheck(this, _class);

    var msgs = args.filter(function (arg) {
      return arg !== '';
    }).map(function (arg) {
      return typeof arg === 'string' ? arg : arg instanceof Error ? arg.message : Stringify(arg);
    });
    _this = _super.call(this, msgs.join(' ') || 'Unknown error');

    if (typeof Error.captureStackTrace === 'function') {
      // $lab:coverage:ignore$
      Error.captureStackTrace(_assertThisInitialized(_this), exports.assert);
    }

    return _this;
  }

  return _class;
}( /*#__PURE__*/_wrapNativeSuper(Error));